"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRouterDom = require("react-router-dom");

var _commonReact = require("@devsta/common-react");

var _basePath = _interopRequireDefault(require("../../common/constants/basePath"));

var _Home = _interopRequireDefault(require("./containers/Home"));

var _ManagePosts = _interopRequireDefault(require("../ManagePosts"));

var _ManageCampaigns = _interopRequireDefault(require("../ManageCampaigns"));

var _ManageCampaign = _interopRequireDefault(require("../ManageCampaign"));

var _ViewCampaign = _interopRequireDefault(require("../ViewCampaign"));

var _FeaturedPosts = _interopRequireDefault(require("../FeaturedPosts"));

var _FavouritePosts = _interopRequireDefault(require("../FavouritePosts"));

var _InspirationWrapper = require("../../common/components/InspirationWrapper");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var ManagePostsComponent = (0, _commonReact.requiresPermission)({
  ComponentToRender: _ManagePosts.default,
  requiredPermission: 'MANAGE_INSPIRATIONS',
  isRoute: true,
  Fallback: _commonReact.NotFound
});
var ManageCampaignsComponent = (0, _commonReact.requiresPermission)({
  ComponentToRender: _ManageCampaigns.default,
  requiredPermission: 'MANAGE_INSPIRATION_CAMPAIGNS',
  isRoute: true,
  Fallback: _commonReact.NotFound
});
var ManageCampaignComponent = (0, _commonReact.requiresPermission)({
  ComponentToRender: _ManageCampaign.default,
  requiredPermission: 'MANAGE_INSPIRATION_CAMPAIGNS',
  isRoute: true,
  Fallback: _commonReact.NotFound
});
var routes = [{
  component: _Home.default,
  exact: true,
  path: "".concat(_basePath.default, "/")
}, {
  component: ManagePostsComponent,
  exact: true,
  path: "".concat(_basePath.default, "/manage")
}, {
  component: ManageCampaignsComponent,
  exact: true,
  path: "".concat(_basePath.default, "/manage/campaigns")
}, {
  component: ManageCampaignComponent,
  exact: true,
  path: "".concat(_basePath.default, "/manage/campaigns/:id")
}, {
  component: _ViewCampaign.default,
  exact: true,
  path: "".concat(_basePath.default, "/view/campaigns/:id")
}, {
  component: _FeaturedPosts.default,
  exact: true,
  path: "".concat(_basePath.default, "/featured-posts")
}, {
  component: _FavouritePosts.default,
  exact: true,
  path: "".concat(_basePath.default, "/favourite-posts")
}];

var Home = function Home() {
  return _react.default.createElement(_commonReact.AuthorisationConsumer, {
    requiresOrganisation: true
  }, function (_ref) {
    var organisationMemberships = _ref.organisationMemberships,
        organisationId = _ref.selectedOrganisation.organisationId;
    return _react.default.createElement(_InspirationWrapper.InspirationOrgProvider, {
      organisationMemberships: organisationMemberships,
      organisationId: organisationId
    }, _react.default.createElement(_reactRouterDom.Switch, null, routes.map(function (route) {
      return _react.default.createElement(_reactRouterDom.Route, _extends({
        key: route.path
      }, route));
    }), _react.default.createElement(_reactRouterDom.Redirect, {
      exact: true,
      from: "/",
      to: "".concat(_basePath.default)
    })));
  });
};

var _default = Home;
exports.default = _default;